import { render, staticRenderFns } from "./PaySectionPage.vue?vue&type=template&id=4a01e254&"
import script from "./PaySectionPage.vue?vue&type=script&lang=js&"
export * from "./PaySectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports